"use client";

import HeroSection from "@/components/common/HeroSection";
import MiniCard from "@/components/common/MiniCard";

import {
  MvpData,
  points,
  ImageCardData,
  ProcessData,
  statsData,
} from "@/constants/MvpData";
import ImageCard from "@/components/common/ImageCard";
import { useIsDark } from "@/context/ThemeContext";
import SectionHeader from "@/components/common/SectionHeader";
import CheckMarks from "@/components/common/CheckMarks";
import Process from "@/components/common/Process";
import { twMerge } from "tailwind-merge";
import ReviewSlider from "@/components/Reviews";
import GradientBottom from "@/components/common/GradientBottom";
import StatsCardsContainer from "@/components/StatCard";

// throw new error("test");
export default function MVP() {
  const isdark = useIsDark();

  return (
    <>
      <div className="relative flex flex-col justify-center items-center mt-6 mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150] z-10">
        <section>
          <HeroSection
            heading="MVP Development"
            subHeading="Build Fast. Build Smart. Build With Clarity."
            paragraph="Designed to validate your vision, reduce uncertainty, and launch a scalable MVP with a clear, guided process."
            headingStyles="text-[35px] mobile:text-[45px] sm:text-[60px] md:text-[75px] tablet:text-[95px] lg:text-[105px] xl:text-[135px] laptop:text-[155px] 3xl:text-[190px] 4xl:text-[210px] leading-[100%] text-center"
            paragraphStyles="font-alexandria font-medium"
          />
        </section>

        <section>
          <SectionHeader
            title={"what we do"}
            description={
              "We help founders turn early ideas into a clear, focused, launch-ready MVP through structured discovery, guided feature planning, and scalable engineering. Our approach removes uncertainty, reduces cost, and ensures your MVP is built with clarity from day one."
            }
            wrapperClassName="xl:mt-0 xl:mb-0 px-0"
            titleClassName="xl:text-[35px]"
          />
        </section>

        <section className="flex flex-col w-full max-w-[2000px] items-center xl:mt-[133px]">
          <SectionHeader
            title={"Our MVP development services include:"}
            wrapperClassName="xl:mt-0 xl:mb-0 px-0"
            titleClassName="text-[25px]"
          />

          <div className="grid mobile:grid-cols-2 tablet:grid-cols-4 gap-[19px] md:gap-x-[35px] tablet:gap-4 xl:gap-[19px] 3xl:gap-[25px] xl:mt-[50px] auto-rows-fr">
            {MvpData.map((item, index) => (
              <MiniCard
                key={index}
                icon={item.icon}
                heading={item.heading}
                paragraph={item.paragraph}
                cardStyles="md:pb-[35px] tablet:pb-[25px] tablet:px-3 lg:px-5 3xl:px-6 3xl:pb-10"
                headingStyles="tablet:text-[18px] lg:text-[20px] laptop:text-[22px]"
                paragraphStyles="laptop:text-[20px]"
                // cardStyles="w-[296px] h-[350px]"
              />
            ))}
          </div>
        </section>
      </div>

      <section
        className={twMerge(
          "relative flex flex-col items-center w-full py-[25px] xl:py-[50px] px-5 md:px-10 xl:px-[100px] mt-10 3xl:mt-15 z-10",
          isdark ? "bg-[#2D2D2D]/50" : "bg-[#F2E4FE]/50"
        )}
      >
        <div className="w-full max-w-[2000px]">
          <SectionHeader
            title={"Why Choose an MVP?"}
            description={
              "A well-structured MVP reduces risk, saves cost, and helps you launch with clarity and confidence."
            }
            wrapperClassName="mt-0 mb-0 px-0"
            descriptionClassName="xl:mt-[50px]"
          />
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0 mt-[25px] xl:mt-[50px]">
            <div className="md:w-[50vw]">
              <CheckMarks points={points} />
            </div>
            <div>
              <StatsCardsContainer
                statsData={statsData}
                gridStyles="p-2 gap-4 laptop:gap-10"
                cardStyles="  w-full xl:w-[170px] laptop:w-[180px] xl:h-[155px] laptop:h-[160px]"
                valueSizes="text-center text-[20px] sm:text-[24px] md:text-[24px] xl:text-[30px] laptop:text-[32px]"
                labelSizes="text-center text-[14px] tablet:text-[16px] xl:text-[18px] 3xl:text-[20px]"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="relative flex flex-col justify-center items-center mx-5 md:mx-10 xl:mx-[100px] 3xl:mx-[150] z-10">
        <section>
          <Process Data={ProcessData} sectionHeight={1080} />
        </section>

        {/* <SectionHeader
          title={"Recent MVP Builds"}
          description={
            "We’ve helped startups and entrepreneurs bring their ideas to life, including:"
          }
          wrapperClassName="mt-[50px] mb-0"
        /> */}

        {/* Card slider for small screens */}
        {/* <div className="flex w-full mobile:hidden gap-4 overflow-x-auto snap-x snap-mandatory no-scrollbar">
          {ImageCardData.map((item, index) => (
            <div
              key={index}
              className="shrink-0 basis-[80%] small:basis-[65%]"
            >
              <ImageCard
                image={item.lightImg}
                topic={item.topic}
                text={item.text}
                // tags={item.tags}
                hoverOverlayColor="rgba(26, 26, 26, 0.2)"
              />
            </div>
          ))}
        </div> */}

        {/* <div className="hidden mobile:grid mobile:grid-cols-2 tablet:grid-cols-3 w-full max-w-[2000px] gap-x-4 sm:gap-x-6 2xl:gap-x-8 3xl:gap-x-10 4xl:gap-x-12 gap-y-2 mt-[30px] mx-auto">
          {ImageCardData.map((item, index) => (
            <ImageCard
              key={index}
              image={item.lightImg}
              topic={item.topic}
              text={item.text}
              tags={item.tags}
              hoverOverlayColor="rgba(26, 26, 26, 0.2)"
            />
          ))}
        </div> */}

        <section>
          <SectionHeader
            title={"What Our Clients Say"}
            description={
              "Our work speaks for itself. Hear from businesses that have partnered with us to build high-quality digital solutions, optimize their operations, and achieve measurable success."
            }
            wrapperClassName="mt-20 mb-[50px]"
            titleClassName="xl:text-[35px]"
            descriptionClassName="mt-[50px]"
          />
        </section>

        <ReviewSlider />
      </div>

      <section className="w-full mt-25">
        <GradientBottom
          heading="Ready to Build Your MVP?"
          subHeading="Let’s turn your idea into a reality. Book a free consultation today - no commitment, just expert advice."
          buttonText="Book a Free Consultation"
          buttonHref="/contact#contact-form"
        />
      </section>
    </>
  );
}
